import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import NavLinkAdapter from "@fuse/core/NavLinkAdapter";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { stringAvatar } from "utils/avatarFunctions";
import { Card, CardContent } from "@mui/material";

function LocalListItem({ local }) {
  return (
    <>
      <Card
        component={NavLinkAdapter}
        to={`/local/${local.id}`}
        className="hover:shadow-lg transition-shadow duration-200 w-full"
        sx={{
          bgcolor: "background.paper",
          borderRadius: 2,
          textDecoration: "none !important",
          color: "inherit !important",
        }}
      >
        <CardContent className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 p-4 sm:p-6">
          {/* Avatar + Nombre */}
          <div className="flex items-center w-full sm:w-1/3 gap-3">
            <Avatar {...stringAvatar(local.company_name)} />
            <div className="flex flex-col truncate">
              <Typography variant="h6" className="font-semibold truncate">
                {local.fantasy_name || "Sin nombre"}
              </Typography>
              <div className="flex items-center text-gray-500 text-sm mt-1">
                <FuseSvgIcon size={18} color="disabled">
                  heroicons-solid:credit-card
                </FuseSvgIcon>
                <Typography className="ml-1 truncate">Rut</Typography>
              </div>
              <Typography variant="body2" className="text-gray-500 truncate">
                {local.rut || "-"}
              </Typography>
            </div>
          </div>

          {/* Empresa */}
          <div className="flex flex-col w-full sm:w-1/3 mt-2 sm:mt-0">
            <div className="flex items-center">
              <FuseSvgIcon size={18} color="disabled">
                material-solid:business
              </FuseSvgIcon>
              <Typography className="ml-1 truncate">Compañía</Typography>
            </div>
            <Typography variant="body1" className="font-medium truncate mt-1">
              {local.company_name || "No asignada"}
            </Typography>
          </div>
        </CardContent>
      </Card>
      <Divider />
    </>
  );
}

export default LocalListItem;
